import RouteTemplate from 'ember-route-template'
import CopyClassesPage from 'teacher-ui-client/components/page/copy-classes'

export default RouteTemplate(CopyClassesPage)
